import React from 'react';
import HeaderButton from '../HeaderButton';

const Search = () => {
    const [isOpen, setOpen] = React.useState(false);

    const onToggleSearch = () => setOpen(!isOpen);

    return (
        <div className="search-container">
            <HeaderButton iconName={isOpen ? 'close' : 'search'} onClick={onToggleSearch} />
            {isOpen && <div className={`search-dropdown ${isOpen ? 'opened' : ''}`}>Search will be soon ...</div>}
            {/* TODO: create searchbar */}
        </div>
    );
};

export default Search;
